import React from "react";
import "./Information.scss";

const rootDir = "/documents/";

const links = [
  {
    name: "Устав.pdf",
    link: "2/ustav.pdf"
  },
  {
    name:
      "Лицензия на осуществление образовательной деятельности с приложением.pdf",
    link:
      "2/licenziya_na_osushchestvlenie_obrazovatelnoj_deyatelnosti_s_prilozheniem.pdf"
  },
  {
    name: "Свидетельство о государственной регистрации.pdf",
    link: "2/svidetelstvo_o_gosudarstvennoj_registracii.pdf"
  },
  {
    name: "План финансово-хозяйственной деятельности на 2022-2023 гг.pdf",
    link: "2/plan_finansovo-hozyajstvennoj_deyatelnosti_na_2022-2023_gg.pdf"
  },
  {
    name: "Программа развития до 10 января 2021 года.pdf",
    link: "2/programma_razvitiya_do_10_yanvarya_2021_goda.pdf"
  },
  {
    name: "Отчет о результатах самообследования.pdf",
    link: "2/otchet_o_rezultatah_samoobsledovaniya_2026.pdf"
  },
  {
    name: "Положение об оказании платных образовательных услуг Дизель.pdf",
    link: "2/polozhenie_ob_okazanii_platnyh_obrazovatelnyh_uslug.pdf"
  },
  {
    name: "Приказ о стоимости обучения по программе подготовки категории А.pdf",
    link:
      "2/prikaz_o_stoimosti_obucheniya_po_programme_podgotovki_kategorii_a.pdf"
  },
  {
    name: "Приказ о стоимости обучения по программе подготовки категории В.pdf",
    link:
      "2/prikaz_o_stoimosti_obucheniya_po_programme_podgotovki_kategorii_b.pdf"
  },
  {
    name: "Образец договора об оказании платных образовательных услуг.pdf",
    link: "2/obrazec_dogovora_ob_okazanii_platnyh_obrazovatelnyh_uslug.pdf"
  },
  {
    name: "Аккредитация (Заключение УГИБДД).pdf",
    link: "2/akkreditaciya_zaklyuchenie_ugibdd.pdf"
  },
  {
    name:
      "Акт обследования учебно-материальной базы УГИБДД ГУ МВД России по Пермскому краю.pdf",
    link:
      "2/akt_obsledovaniya_uchebno-materialnoj_bazy_ugibdd_gu_mvd_rossii_po_pemskomu_krayu.pdf"
  },
  {
    name:
      "Предписание № 183 об устранении выявленных нарушений при осуществлении образовательной деятельности.pdf",
    link:
      "2/predpisanie_183_ob_ustranenii_vyyavlennyh_narushenij_pri_osushchestvlenii_obrazovatelnoj_deyatelnosti.pdf"
  },
  {
    name: "Отчет об исполнении предписания.pdf",
    link: "2/otchet_ob_ispolnenii_predpisaniya.pdf"
  },
  {
    name: "Уведомление об исполнении предписания № 183.pdf",
    link: "2/uvedomlenie_ob_ispolnenii_predpisaniya_183.pdf"
  },
  {
    name: "Правила приёма, отчисления и востановления обучающихся.pdf",
    link:
      "2/1/pravila_priyoma_otchisleniya_i_vostanovleniya_obuchayushchihsya.pdf"
  },
  {
    name:
      "Правила внутреннего распорядка обучающихся, правила внутреннего трудового распорядка.pdf",
    link:
      "2/1/pravila_vnutrennego_rasporyadka_obuchayushchihsya_pravila_vnutrennego_trudovogo_rasporyadka.pdf"
  },
  {
    name:
      "Положение о проведении промежуточной аттестации и итогового квалификационного экзамена.pdf",
    link:
      "2/1/polozhenie_o_provedenii_promezhutochnoj_attestacii_i_itogovogo_kvalifikacionnogo_ehkzamena.pdf"
  },
  {
    name:
      "Положение о комиссии по урегулированию споров между участниками образовательных отношений.pdf",
    link:
      "2/1/polozhenie_o_komissii_po_uregulirovaniyu_sporov_mezhdu_uchastnikami_obrazovatelnyh_otnoshenij.pdf"
  },
  {
    name:
      "Положение о порядке пользования учебниками, учебными пособиями и другой методической литературой обучающимися.pdf",
    link:
      "2/1/polozhenie_o_poryadke_polzovaniya_uchebnikami_uchebnymi_posobiyami_i_drugoj_metodicheskoj_literaturoj_obuchayushchimisya.pdf"
  },
  {
    name:
      "Положение о порядке доступа педработников к информационно-телекоммуникационным сетям и базам данных.pdf",
    link:
      "2/1/polozhenie_o_poryadke_dostupa_pedrabotnikov_k_informacionno-telekommunikacionnym_setyam_i_bazam_dannyh.pdf"
  },
  {
    name:
      "Порядок бесплатного пользования педработниками образовательными, методическими и научными услугами образовательной организации.pdf",
    link:
      "2/1/poryadok_besplatnogo_polzovaniya_pedrabotnikami_obrazovatelnymi_metodicheskimi_i_nauchnymi_uslugami_obrazovatelnoj_organizacii.pdf"
  },
  {
    name: "Положение о нормах профессиональной этики педработников.pdf",
    link: "2/1/polozhenie_o_normah_professionalnoj_ehtiki_pedrabotnikov.pdf"
  },
  {
    name: "Положение о порядке проведения самообследования.pdf",
    link: "2/1/polozhenie_o_poryadke_provedeniya_samoobsledovaniya.pdf"
  },
  {
    name: "Договор на оказание услуг по организации питания.pdf",
    link: "2/1/dogovor_na_okazanie_uslug_po_organizacii_pitaniya.pdf"
  },
  {
    name:
      "Рабочая программа профессионального обучения водителей транспортных средств категории A.pdf",
    link: "3/rabochaya_programma_kategorii_a_2026.pdf"
  },
  {
    name:
      "Рабочая программа профессионального обучения водителей транспортных средств категории В.pdf",
    link: "3/rabochaya_programma_kategorii_b_2026.pdf"
  },
  {
    name:
      "Аннотация к рабочей программе обучения водителей транспортных средств категории А.pdf",
    link:
      "2/annotaciya_k_rabochej_programme_obucheniya_voditelej_transportnyh_sredstv_kategorii_a.pdf"
  },
  {
    name:
      "Аннотация к рабочей программе обучения водителей транспортных средств категории В.pdf",
    link:
      "2/annotaciya_k_rabochej_programme_obucheniya_voditelej_transportnyh_sredstv_kategorii_b.pdf"
  },
  {
    name: "Программа Основы экстремального вождения.pdf",
    link: "3/programma_osnovy_ehkstremalnogo_vozhdeniya.pdf"
  },
  {
    name: "Программа Основы безопасного управления транспортным средством.pdf",
    link:
      "3/programma_osnovy_bezopasnogo_upravleniya_transportnym_sredstvom.pdf"
  },
  {
    name:
      "Годовой календарный учебный график профессионального обучения водителей транспортных средств категории A.pdf",
    link:
      "3/godovoj_kalendarnyj_uchebnyj_grafik_professionalnogo_obucheniya_voditelej_transportnyh_sredstva_kategorii_a.pdf"
  },
  {
    name:
      "Годовой календарный учебный график профессионального обучения водителей транспортных средств категории B.pdf",
    link:
      "3/godovoj_kalendarnyj_uchebnyj_grafik_professionalnogo_obucheniya_voditelej_transportnyh_sredstva_kategorii_b.pdf"
  },
  {
    name:
      "Календарный учебный график профессионального обучения водителей транспортных средств категории A.pdf",
    link:
      "3/kalendarnyj_uchebnyj_grafik_professionalnogo_obucheniya_voditelej_transportnyh_sredstva_kategorii_a.pdf"
  },
  {
    name:
      "Календарный учебный график профессионального обучения водителей транспортных средств категории B.pdf",
    link:
      "3/kalendarnyj_uchebnyj_grafik_professionalnogo_obucheniya_voditelej_transportnyh_sredstva_kategorii_b.pdf"
  },
  {
    name:
      "Рабочий учебный план профессионального обучения водителей транспортных средств категории A. pdf",
    link:
      "3/rabochij_uchebnyj_plan_professionalnogo_obucheniya_voditelej_transportnyh_sredstv_kategorii_a.pdf"
  },
  {
    name:
      "Рабочий учебный план профессионального обучения водителей транспортных средств категории В. pdf",
    link:
      "3/rabochij_uchebnyj_plan_professionalnogo_obucheniya_voditelej_transportnyh_sredstv_kategorii_b.pdf"
  },
  {
    name: "Методические указания по организации учебного процесса.pdf",
    link: "3/metodicheskie_ukazaniya_po_organizacii_uchebnogo_processa.pdf"
  },
  {
    name:
      "Положение о порядке выдачи документов об образовании и их дубликатов с приложением.pdf",
    link:
      "3/polozhenie_o_poryadke_vydachi_dokumentov_ob_obrazovanii_i_ih_dublikatov_s_prilozheniem.pdf"
  },
  {
    name: "Образец свидетельства о профессии водитель.pdf",
    link: "3/obrazec_svidetelstva_o_professii_voditel.pdf"
  },
  {
    name:
      "Сведения о наличии в собственности или на ином законном основании оборудованных учебных транспортных средств.pdf",
    link:
      "4/svedeniya_o_nalichii_v_sobstvennosti_ili_na_inom_zakonnom_osnovanii_oborudovannyh_uchebnyh_transportnyh_sredstv.pdf"
  },
  {
    name: "Материально техническое обеспечение образовательного процесса.pdf",
    link: "4/materialno_tekhnicheskoe_obespechenie_obrazovatelnogo_processa.pdf"
  }
];

const generateLinks = (list) => {
  const filterByName = (name) => (element) => {
    if (typeof name === "string") {
      return element.name === name;
    }
    if (Array.isArray(name) === true) {
      return name.includes(element.name);
    }
  };

  const arrByName = (array) => (name) => {
    return array.filter(filterByName(name));
  };

  const linksByName = arrByName(links);

  if (Array.isArray(list) === true) {
    return (
      <ul className="list_no-style">
        {linksByName(list).map((unit, i) => {
          return (
            <li key={i}>
              <a
                target="_blank"
                href={`${rootDir}${unit.link}`}
                className="link"
              >
                {unit.name}
              </a>
            </li>
          );
        })}
      </ul>
    );
  }
  if (typeof list === "string") {
    return (
      <ul className="list_no-style">
        {linksByName(list).map((unit, i) => {
          return (
            <a
              key={i}
              target="_blank"
              href={`${rootDir}${unit.link}`}
              className="link"
            >
              {unit.name}
            </a>
          );
        })}
      </ul>
    );
  }
};

function Main() {
  return (
    <article>
      <p>
        Частное учреждение дополнительного профессионального образования
        «Дизель»
      </p>
      <ul className="list_no-style">
        <li>
          <span className="important">Директор:</span> Половодова Тамара
          Васильевна
        </li>
        <li>
          <span className="important">Учредитель ЧУ ДПО «Дизель»:</span>{" "}
          Половодова Тамара Васильевна
        </li>
        <li>
          <span className="important">Дата регистрации:</span> 13.03.2008 г.
        </li>
        <li>ОГРН 1085900000570</li>
        <li>ИНН 5904184520</li>
        <li>
          Лицензия на право обучения водителей категории «В», «А» серия 59л01 №
          0003542 от 08.11.2016 г. выдана Государственной Инспекцией по надзору
          и контролю в сфере образования Пермского края. Срок действия лицензии
          «бессрочно».
        </li>
        <li>
          Автошкола на основании лицензии и приложения к ней осуществляет
          обучение по программам профессиональной подготовки водителей
          транспортных средств категорий «А», «В». По итогам обучения выдается
          Свидетельство о профессии водителя.
        </li>
        <li>
          <span className="important">Юридический адрес: </span>614039, г.
          Пермь, ул. Пушкина, 80-21.
        </li>
        <li>
          <h6 className="important">
            Адреса осуществления образовательной деятельности:
          </h6>
          <ol>
            <li>
              Места осуществления образовательной деятельности при использовании
              сетевой формы реализации образовательных программ: не
              предусмотрено.
            </li>
            <li>Места проведения практики: г. Пермь, ул. Соликамская, 286.</li>
            <li>
              Места проведения практической подготовки обучающихся: г. Пермь,
              ул. Соликамская, 286.
            </li>
            <li>
              Места проведения государственной итоговой аттестации: г. Пермь,
              ул. Максима Горького, 21.
            </li>
            <li>
              Места осуществления образовательной деятельности по дополнительным
              образовательным программам: г. Пермь, ул. Максима Горького, 21.
            </li>
            <li>
              Места осуществления образовательной деятельности по основным
              программам профессионального обучения: г. Пермь, ул. Максима
              Горького, 21.
            </li>
          </ol>
        </li>
        <li>
          <span className="important">Телефон: </span>+7 (951) 938-40-29
        </li>
        <li>
          <span className="important">Электронная почта: </span>
          <a
            href="mailto:tamara.polovodova@yandex.ru?subject=Автошкола"
            className="link"
          >
            tamara.polovodova@yandex.ru
          </a>
        </li>
        <li>
          <span className="important">Официальный сайт: </span>
          <a href="http://dieselperm.ru" className="link">
            http://dieselperm.ru
          </a>
        </li>
        <li>
          <span className="important">Режим работы: </span>
          понедельник-пятница с 9:00 до 20:00, суббота-воскресенье выходной
        </li>
      </ul>
    </article>
  );
}

function Structure() {
  return (
    <article>
      <p>
        Структура и органы управления ЧУ ДПО «Дизель», порядок и формирование,
        сроки полномочий и порядок деятельности органов, определены Уставом ЧУ
        ДПО «Дизель» в соответствии с действующим законодательством Российской
        Федерации.
      </p>
      <p>
        Органами управления ЧУ ДПО «Дизель» являются:
        <ul>
          <li>Учредитель Половодова Тамара Васильевна;</li>
          <li>Директор Половодова Тамара Васильевна на основании устава;</li>
          <li>Общее собрание работников - коллегиальный орган управления;</li>
          <li>Педагогический совет - коллегиальный орган управления.</li>
        </ul>
        <ul className="list_no-style">
          <li>Обособленных структурных подразделений учреждение не имеет.</li>
          <li>
            Высшим органом управления организации является учредитель Половодова
            Тамара Васильевна.
          </li>
          <li>
            Единоличным исполнительным органом является директор автошколы
            Половодова Тамара Васильевна.
          </li>
          <li>
            <span className="important">Телефон:</span> +7 (951) 938-40-29
          </li>
          <li>
            <span className="important">Электронная почта: </span>
            <a
              href="mailto:tamara.polovodova@yandex.ru?subject=Автошкола"
              className="link"
            >
              tamara.polovodova@yandex.ru
            </a>
          </li>
          <li>
            <span className="important">Официальный сайт: </span>
            <a href="http://dieselperm.ru" className="link">
              http://dieselperm.ru
            </a>
          </li>
        </ul>
      </p>
      <p>{generateLinks("Устав.pdf")}</p>
      <p>
        К компетенции Учредителя относится:
        <ul>
          <li>внесение изменений и дополнений в Устав Учереждения;</li>
          <li>назначение директора;</li>
          <li>
            установление исходных данных планирования финансово – хозяйственной
            деятельности Учереждения, контрольных цифр приема и выпуска
            обучающихся;
          </li>
          <li>утверждение сметы расходов;</li>
          <li>
            приостановление предпринимательской деятельности Учереждения, если
            она идет в ущерб основной уставной деятельности;
          </li>
          <li>
            получение от Учереждения информации о его деятельности, отчетов о
            поступлении и расходовании средств;
          </li>
          <li>
            осуществление контроля над соответствием деятельности Учереждения
            его Уставу;
          </li>
          <li>
            проведение комплексных ревизий финансово – хозяйственной
            деятельности и проверок;
          </li>
          <li>
            ликвидация и реорганизация Учереждения в соответствии с
            законодательством РФ и Уставом.
          </li>
        </ul>
      </p>
      <p>
        Директор Учереждения назначается на должность приказом учредителя и
        наделяется в соответствии законодательством РФ всеми необходимыми
        полномочиями для осуществления оперативного руководства его
        деятельностью, на основании трудового договора (контракта), за
        исключением решения вопросов, отнесенных к компетенции Учредителей.
      </p>
      <p>
        Правомочия директора общества могут продлеваться неограниченное
        множество раз на основании решения Учредителей.
      </p>
      <p>
        Директор осуществляет свою деятельность в соответствии с должностными
        инструкциями, трудовым договором (контракт) и Уставом. К его компетенции
        относится:
        <ul>
          <li>
            ответственность за образовательный процесс, финансовую и
            хозяйственную деятельность Общества;
          </li>
          <li>
            осуществление действий без доверенности от имени и в интересах
            Учреждения по всем вопросам, не отнесенным настоящим Уставом к
            исключительной компетенции Учредителя;
          </li>
          <li>
            распоряжается средствами и имуществом Учереждения, заключает
            договоры, в том числе трудовые, выдает доверенности;
          </li>
          <li>открывает в банковских учреждениях расчетные и иные счета;</li>
          <li>формирует штаты Учереждения;</li>
          <li>
            издает локальные акты, регламентирующие деятельность Учереждения;
          </li>
          <li>
            открывает филиалы, координирует и контролирует деятельность филиалов
            и структурных подразделений, педагогических и других работников,
            создает условия для повышения их профессионального мастерства;
          </li>
          <li>
            поощряет и стимулирует творческую инициативу работников,
            поддерживает благоприятный морально-психологический климат в
            коллективе;
          </li>
          <li>
            несет персональную ответственность за сохранность документации,
            отражающей финансово-хозяйственную деятельность, прием, перемещение,
            увольнение персонала Учереждения и передачу учредительных документов
            в Государственный архив в соответствии с требованиями действующего
            законодательства.
          </li>
        </ul>
      </p>
    </article>
  );
}

function Documents() {
  return (
    <article>
      {generateLinks([
        "Устав.pdf",
        "Лицензия на осуществление образовательной деятельности с приложением.pdf",
        "Свидетельство о государственной регистрации.pdf",
        "План финансово-хозяйственной деятельности на 2022-2023 гг.pdf",
        "Программа развития до 10 января 2021 года.pdf",
        "Отчет о результатах самообследования.pdf",
        "Положение об оказании платных образовательных услуг Дизель.pdf",
        "Приказ о стоимости обучения по программе подготовки категории А.pdf",
        "Приказ о стоимости обучения по программе подготовки категории В.pdf",
        "Образец договора об оказании платных образовательных услуг.pdf",
        "Аккредитация (Заключение УГИБДД).pdf",
        "Акт обследования учебно-материальной базы УГИБДД ГУ МВД России по Пермскому краю.pdf",
        "Предписание № 183 об устранении выявленных нарушений при осуществлении образовательной деятельности.pdf",
        "Отчет об исполнении предписания.pdf",
        "Уведомление об исполнении предписания № 183.pdf"
      ])}
      <h5 className="important">Локальные нормативные акты:</h5>
      {generateLinks([
        "Правила приёма, отчисления и востановления обучающихся.pdf",
        "Правила внутреннего распорядка обучающихся, правила внутреннего трудового распорядка.pdf",
        "Положение о проведении промежуточной аттестации и итогового квалификационного экзамена.pdf",
        "Положение о комиссии по урегулированию споров между участниками образовательных отношений.pdf",
        "Положение о порядке пользования учебниками, учебными пособиями и другой методической литературой обучающимися.pdf",
        "Положение о порядке доступа педработников к информационно-телекоммуникационным сетям и базам данных.pdf",
        "Порядок бесплатного пользования педработниками образовательными, методическими и научными услугами образовательной организации.pdf",
        "Положение о нормах профессиональной этики педработников.pdf",
        "Положение о порядке проведения самообследования.pdf"
      ])}
    </article>
  );
}

function Education() {
  return (
    <article>
      <p>
        Уровень образования, реализуемый в автошколе – профессиональная
        подготовка.
      </p>
      <p>
        Форма обучения по теоретическому курсу очная, в группе или
        индивидуальная (дневная, вечерняя), по практическому вождению — только
        индивидуальная, очная (дневная, вечерняя). Основными видами обучения
        являются теоретические, практические и контрольные занятия.
      </p>
      <p>
        Нормативные сроки обучения устанавливаются календарным учебным графиком
        исходя из объемов учебных планов и программ, режимов обучения, а также
        от количества обучающихся и от количества инструкторов по вождению и
        согласуются с экзаменационным подразделением ГИБДД.
      </p>
      <p>
        Нормативные сроки обучения:
        <ul>
          <li>
            По программе подготовки водителей категории «В» — 190 часов
            (механическая коробка переключения передач) и 188 часов
            (автоматизированная коробка переключения передач), срок обучения 3,5
            месяца (вождение автомобиля проводится вне сетки учебного времени).
          </li>
          <li>
            По программам подготовки водителей категории «А» — 130 часов
            (механическая коробка переключения передач) и 128 часов
            (автоматизированная коробка переключения передач), срок обучения 2,5
            месяца (вождение мотоцикла проводится вне сетки учебного времени).
          </li>
        </ul>
      </p>
      <h4>Описание образовательных программ:</h4>
      <p>
        Учебные планы и программы подготовки и переподготовки водителей
        транспортных средств разрабатываются автошколой на основании
        государственных образовательных стандартов и нормативных актов,
        соответствующих примерным образовательным программам.
      </p>
      <p>
        В рабочей программе содержание образования разделено на циклы:
        <ul>
          <li>
            базовый (изучается один раз при получении любой категории или
            подкатегории и перезачитывается при обучении на любую другую
            категорию);
          </li>
          <li>
            специальный, необходимый для подготовки водителей транспортных
            средств определенной категории или подкатегории;
          </li>
          <li>
            профессиональный цикл, обеспечивающий освоение основ профессии
            водителя (изучается при обучении на те категории и подкатегории
            транспортных средств, которые могут осуществлять перевозку
            пассажиров и грузов, в т.ч. на категорию «В»).
          </li>
        </ul>
      </p>
      <p>
        При этом последовательность изучения разделов и тем учебных предметов
        базового, специального и профессионального циклов определяется
        автошколой.
      </p>
      {generateLinks([
        "Рабочая программа профессионального обучения водителей транспортных средств категории A.pdf",
        "Рабочая программа профессионального обучения водителей транспортных средств категории В.pdf",
        "Аннотация к рабочей программе обучения водителей транспортных средств категории А.pdf",
        "Аннотация к рабочей программе обучения водителей транспортных средств категории В.pdf",
        "Программа Основы экстремального вождения.pdf",
        "Программа Основы безопасного управления транспортным средством.pdf",
        "Годовой календарный учебный график профессионального обучения водителей транспортных средств категории A.pdf",
        "Годовой календарный учебный график профессионального обучения водителей транспортных средств категории B.pdf",
        "Календарный учебный график профессионального обучения водителей транспортных средств категории A.pdf",
        "Календарный учебный график профессионального обучения водителей транспортных средств категории B.pdf",
        "Рабочий учебный план профессионального обучения водителей транспортных средств категории A. pdf",
        "Рабочий учебный план профессионального обучения водителей транспортных средств категории В. pdf",
        "Методические указания по организации учебного процесса.pdf"
      ])}
      <p>
        Учебные группы по подготовке (переподготовке) водителей комплектуются
        численностью не более 20 человек.
      </p>
      <p>
        Материальная база ЧУ ДПО «Дизель» на основании заключения УГИБДД ГУ
        РОССИИ по Пермскому краю № 62/59 от 26.01.2015 г. (бессрочное) позволяет
        обучать 152 человека. Группы регистрируются в РЭО ГИБДД УМВД РОССИИ по
        г. Перми.
      </p>
      <p>Язык преподавания в автошколе — русский.</p>
      <p>
        Количество вакантных мест для приема на обучение за счет бюджетных
        ассигнований федерального бюджета, бюджетов субъектов Российской
        Федерации, местных бюджетов – не предусмотрено.
      </p>
      <p>Наименование профессии: Водитель транспортных средств.</p>
      <p>
        По окончании обучения при условии успешной сдачи зачетов по предметам и
        квалификационного экзамена учащемуся выдается Свидетельство о профессии
        водителя.
      </p>
      {generateLinks([
        "Положение о проведении промежуточной аттестации и итогового квалификационного экзамена.pdf",
        "Положение о порядке выдачи документов об образовании и их дубликатов с приложением.pdf"
      ])}
      <p>Образец документа об успешном окончании обучения:</p>
      {generateLinks(["Образец свидетельства о профессии водитель.pdf"])}
      <h4>Режим занятий, установленный правилами внутреннего распорядка:</h4>
      <p>
        Занятия в автошколе проводятся на основании расписаний теоретических
        занятий и графиков учебного вождения.
      </p>
      <p>
        Продолжительность учебного часа теоретических и лабораторно-практических
        занятий — 45 минут (академический час), в расписании предусмотрены
        спаренные уроки по предмету, т.е. 1 час 30 минут.
      </p>
      <p>
        Режим теоретических занятий устанавливается исходя из расписания. В
        автошколе занятия по теоретическому курсу могут проводиться в утреннее,
        дневное или вечернее время, 3-4 раза в неделю в период
        понедельник-пятница:
        <ul className="list_no-style">
          <li>Утренние занятия - с 9:00 до 10:30</li>
          <li>Вечерние занятия - с 19:00 до 20:30</li>
        </ul>
      </p>
      <p>
        Занятия по вождению автомобиля (мотоцикла) проводятся по индивидуальному
        графику, согласованному учащимся с мастером производственного обучения,
        преимущественно в дневное рабочее время. В случае производственной
        необходимости, а так же по индивидуальным запросам учащихся занятия по
        вождению могут быть организованы в ранние утренние часы (с 8:00 до
        10:00), либо в вечерние с 9:00 до 21:00), а также в субботние или
        воскресные дни.
      </p>
      <p>
        Продолжительность учебного часа практических занятий по вождению
        транспортных средств — 60 минут (астрономический час), включая время на
        постановку задач, подведение итогов, оформление документации и смену
        обучаемых.
      </p>
      <p>
        Одно практическое занятие поводится в объеме одного-двух астрономических
        часов, т.е. 60-120 минут. По желанию учащегося возможно проведение в
        день двух занятий по вождению, с обязательным перерывом между ними.
      </p>
      <p>
        Теоретические занятия проводятся преподавателем, практические занятия по
        вождению автомобиля проводятся мастером производственного обучения
        вождению индивидуально с каждым обучаемым, по оказанию первой помощи —
        медицинским работником.
      </p>
      <p>
        Теоретические занятия проводятся в специально оборудованных классах
        (кабинетах) в составе учебной группы с целью изучения нового материала.
      </p>
      <p>
        Занятия по практическому вождению проводятся индивидуально с каждым
        обучаемым на автодромах и учебных маршрутах, согласованных с органами
        ГИБДД.
      </p>
      <p>
        К практическому вождению, связанному с выездом на дороги общего
        пользования, допускаются лица, имеющие достаточные навыки
        первоначального управления транспортным средством (на автодроме) и
        прошедшие соответствующую проверку знаний Правил дорожного движения.
      </p>
      <p>
        Автошкола имеет право уведомить обучающегося о нецелесообразности
        дальнейшего обучения вследствие его индивидуальных особенностей,
        делающих невозможным или педагогически нецелесообразным дальнейшее
        обучение.
      </p>
      <p>
        Автошкола отвечает за поддержание транспортных средств в технически
        исправном состоянии и организацию предрейсового медицинского осмотра
        мастеров производственного обучения вождению и водителей. Проверка
        технического состояния автомобилей и проведение предрейсового
        медицинского осмотра отражается в путевом листе.
      </p>
      {generateLinks([
        "Правила внутреннего распорядка обучающихся, правила внутреннего трудового распорядка.pdf"
      ])}
    </article>
  );
}

function EducationStandart() {
  return (
    <article>
      <p>
        Профессиональная подготовка водителей транспортных средств в настоящее
        время не регламентируется федеральными государственными образовательными
        стандартами.
      </p>
      <p>
        Образовательное учреждение при разработке программ обучения
        ориентируется на действующее законодательство Российской Федерации, в
        частности на:
        <p>
          <a
            target="_blank"
            className="link"
            href="http://base.garant.ru/70695708/#ixzz5a2NQDfja"
          >
            Приказ Министерства образования и науки РФ от 26 декабря 2013 г. №
            1408 "Об утверждении примерных программ профессионального обучения
            водителей транспортных средств соответствующих категорий и
            подкатегорий"
          </a>
        </p>
      </p>
      <h5>
        Планируемые результаты освоения программы профессиональной подготовки
        водителей транспортных средств различных категорий
      </h5>
      <p>
        В результате освоения программы обучающиеся должны знать:
        <ul>
          <li>
            правила дорожного движения, основы законодательства в сфере
            дорожного движения;
          </li>
          <li>
            правила обязательного страхования гражданской ответственности
            владельцев транспортных средств, порядок составления «европротокола»
            при возникновении ДТП;
          </li>
          <li>основы безопасного управления транспортными средствами;</li>
          <li>
            цели и задачи управления системами «водитель – автомобиль – дорога»
            и «водитель – автомобиль»;
          </li>
          <li>особенности наблюдения за дорожной обстановкой;</li>
          <li>способы контроля безопасной дистанции и бокового интервала;</li>
          <li>порядок вызова аварийных и спасательных служб;</li>
          <li>
            основы обеспечения безопасности наиболее уязвимых участников
            дорожного движения: пешеходов, велосипедистов;
          </li>
          <li>основы обеспечения детской пассажирской безопасности;</li>
          <li>
            проблемы, связанные с нарушением правил дорожного движения
            водителями транспортных средств и их последствиями;
          </li>
          <li>
            правовые аспекты (права, обязанности и ответственность) оказания
            первой помощи;
          </li>
          <li>современные рекомендации по оказанию первой помощи;</li>
          <li>
            методики и последовательность действий по оказанию первой помощи;
          </li>
          <li>
            состав аптечки первой помощи (автомобильной) и правила использования
            ее компонентов.
          </li>
        </ul>
      </p>
      <p>
        В результате освоения программы обучающиеся должны уметь:
        <ul>
          <li>
            безопасно и эффективно управлять транспортным средством (составом
            транспортных средств) в различных условиях движения;
          </li>
          <li>
            соблюдать Правила дорожного движения при управлении транспортным
            средством (составом транспортных средств);
          </li>
          <li>управлять своим эмоциональным состоянием;</li>
          <li>
            конструктивно разрешать противоречия и конфликты, возникающие в
            дорожном движении;
          </li>
          <li>
            выполнять ежедневное техническое обслуживание транспортного средства
            (состава транспортных средств);
          </li>
          <li>
            устранять мелкие неисправности в процессе эксплуатации транспортного
            средства (состава транспортных средств);
          </li>
          <li>
            обеспечивать безопасную посадку и высадку пассажиров, их перевозку,
            либо прием, размещение и перевозку грузов;
          </li>
          <li>
            выбирать безопасные скорость, дистанцию и интервал в различных
            условиях движения;
          </li>
          <li>
            информировать других участников движения о намерении изменить
            скорость и траекторию движения транспортного средства, подавать
            предупредительные сигналы;
          </li>
          <li>использовать зеркала заднего вида при маневрировании;</li>
          <li>
            прогнозировать и предотвращать возникновение опасных
            дорожно-транспортных ситуаций в процессе управления транспортным
            средством (составом транспортных средств);
          </li>
          <li>
            своевременно принимать правильные решения и уверенно действовать в
            сложных и опасных дорожных ситуациях;
          </li>
          <li>
            выполнять мероприятия по оказанию первой помощи пострадавшим в
            дорожно-транспортном происшествии;
          </li>
          <li>
            совершенствовать свои навыки управления транспортным средством
            (составом транспортных средств).
          </li>
        </ul>
      </p>
    </article>
  );
}

function Manager() {
  return (
    <article>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Директор автошколы ЧУ ДПО "Дизель"- Половодова Тамара Васильевна
          </li>
          <li>Образование: Пермский государственный университет 1987 г.</li>
          <li>Специальность: физик, преподаватель физики.</li>
          <li>
            Повышение квалификации по дополнительной профессиональной программе
            "Современные технологии административной деятельности руководителя
            образовательной организации: управленческие и юридические
            компетенции",
          </li>
          <li>АНО ДПО "УрИПКиП", 2018 г.</li>
          <li>Контактные телефоны: +7 (951) 938-40-29</li>
          <li>Электронная почта: tamara.polovodova@yandex.ru</li>
          <li />
        </ul>
      </p>
      <h4>Сведения о преподавателях учебных классов:</h4>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Преподаватель Половодова Тамара Васильевна
          </li>
          <li>Дата рождения: 13.07.1964 г.</li>
          <li>
            Образование: высшее, Пермский государственный университет, 1987 г.
          </li>
          <li>
            Специальность: физик, преподаватель физики.
            <ul>
              <li>
                Имеет удостоверение о дополнительном профессиональном
                образовании по педагогическим основам деятельности преподавателя
                по подготовке водителей транспортных средств.
              </li>
              <li>
                Повышение квалификации преподавателей, осуществляющих подготовку
                водителей транспортных средств от 26.10.2021 г.;
              </li>
              <li>
                Повышение квалификации «Контролер технического состава
                автотранспортных средств» от 28.06.2017
              </li>
              <li>
                Повышение квалификации «Современные технологии административной
                деятельности руководителя образовательной организации:
                управленческие и юридические компетенции» от 23.11.2018 г.
              </li>
              <li>
                Повышение квалификации «Слесарь по ремонту автомобилей третьего
                разряда» от 17.06.2020 г.
              </li>
            </ul>
          </li>
          <li>Общий стаж преподавания: с 2008 г.</li>
          <li>Стаж преподавания по профилю: с 2008 г.</li>
          <li>
            Преподает в учебном классе дисциплины: основы законодательства в
            сфере дорожного движения, устройство и техническое обслуживание
            транспортных средств, основы безопасного управления транспортным
            средством.
          </li>
        </ul>
      </p>
      <p>
        <ul className="list_no-style">
          <li className="important">Преподаватель Новикова Светлана Юрьевна</li>
          <li>Дата рождения: 13.10.1981 г.</li>
          <li>
            Образование: высшее, Российская академия ваяния и зодчества, 2007 г.
          </li>
          <li>Специальность: Архитектор.</li>
          <li>
            <ul>
              <li>
                Повышение квалификации «Слесарь по ремонту автомобилей третьего
                разряда» от 17.06.2020 г.
              </li>
              <li>
                Повышение квалификации «Психология дорожного движения в системе
                подготовки преподавателей автошкол и инструкторов по вождению»
                от 28.04.2021 г.
              </li>
              <li>
                Повышение квалификации по программе «Мастер профессионального
                обучения вождению транспортных средств соответствующих категорий
                и подкатегорий» от 25.02.2021 г.
              </li>
            </ul>
          </li>
          <li>Стаж преподавания по профилю: с 2017 г.</li>
          <li>
            Преподает в учебном классе Психофизические основы деятельности
            водителя.
          </li>
        </ul>
      </p>
      <h4>Сведения о мастерах производственного обучения:</h4>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Мастер производственного обучения Половодов Евгений Васильевич
          </li>
          <li>
            Образование: высшее, Пермский государственный университет, 1986 г.
          </li>
          <li>Специальность: физик, преподаватель физики</li>
          <li>
            Серия, № водительского удостоверения, дата выдачи: 5916221886 от
            27.04.2014 г.
          </li>
          <li>Разрешенные категории: В, В1, С, С1, М</li>
          <li>Стаж преподавательской работы: 10 лет</li>
          <li>Удостоверение о повышении квалификации от 19.03.2019 г.</li>
          <li>
            <ul>
              <li>
                Повышение квалификации «Слесарь по ремонту автомобилей третьего
                разряда» от 17.06.2020 г.
              </li>
            </ul>
          </li>
          <li>Стаж преподавания по профилю: с 2019 г. </li>
          <li>Оформлен в соответствии с действующим законодательством.</li>
        </ul>
      </p>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Мастер производственного обучения Половодова Тамара Васильевна
          </li>
          <li>
            Образование: высшее, Пермский государственный университет, 1987 г.
          </li>
          <li>Специальность: физик, преподаватель физики.</li>
          <li>
            Серия, № водительского удостоверения, дата выдачи: 59288 412279 от
            14.07.2016 г.
          </li>
          <li>Разрешенные категории: В, В1, М</li>
          <li>
            <ul>
              <li>
                Повышение квалификации «Слесарь по ремонту автомобилей третьего
                разряда» от 17.06.2020 г.
              </li>
            </ul>
          </li>
          <li>Общий стаж преподавания: с 2008 г. </li>
          <li>Стаж преподавания по профилю: с 2008 г. </li>
          <li>Оформлена в соответствии с действующим законодательством.</li>
        </ul>
      </p>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Мастер производственного обучения Новикова Светлана Юрьевна
          </li>
          <li>
            Образование: высшее, Российская академия ваяния и зодчества, 2007 г.
          </li>
          <li>Специальность: Архитектор.</li>
          <li>
            Серия, № водительского удостоверения, дата выдачи: 5928 843080 от
            19.07.2016 г.
          </li>
          <li>Разрешенные категории: В, В1, М</li>
          <li>
            <ul>
              <li>
                Повышение квалификации «Слесарь по ремонту автомобилей третьего
                разряда» от 17.06.2020 г.
              </li>
              <li>
                Повышение квалификации «Психология дорожного движения в системе
                подготовки преподавателей автошкол и инструкторов по вождению»
                от 28.04.2021 г.
              </li>
              <li>
                Повышение квалификации по программе «Мастер профессионального
                обучения вождению транспортных средств соответствующих категорий
                и подкатегорий» от 25.02.2021 г.
              </li>
            </ul>
          </li>
          <li>Стаж преподавания по профилю: с 2017 г.</li>
          <li>Оформлена в соответствии с действующим законодательством.</li>
        </ul>
      </p>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Мастер производственного обучения Шеромов Сергей Викторович
          </li>
          <li>Образование: высшее, Пермский Политехнический Университет</li>
          <li>
            Серия, № водительского удостоверения, дата выдачи: 5933 778435 от
            29.09.2017 г.
          </li>
          <li>Разрешенные категории: А, А1, В, В1, М</li>
          <li>
            <ul>
              <li>
                Повышение квалификации по программе «Мастер профессионального
                обучения вождению транспортных средств соответствующих категорий
                и подкатегорий» от №0053 от 19.08.2021 г.
              </li>
            </ul>
          </li>
          <li>Стаж преподавания по профилю: с 2017 г.</li>
          <li>Оформлен в соответствии с действующим законодательством.</li>
        </ul>
      </p>
    </article>
  );
}

function Staff() {
  return (
    <article>
      <p>
        Материально-техническое обеспечение образовательной деятельности:
        <ul className="list_no-style">
          <li className="important">
            Сведения об оборудованных учебных кабинетах
          </li>
          <li>
            Теоретические занятия проходят в оборудованном учебном кабинете,
            расположенном по адресу: 614000, г. Пермь, ул. М. Горького, 21 (1
            кабинет).
          </li>
          <li>
            Помещение находится на первом этаже, доступ обучающихся с
            ограниченными возможностями не органичен.
          </li>
          <li>
            Используется образовательной организацией на основании Договора
            аренды б/н от 29.01.2021 г. с ИП Снигеревым А.И., бессрочно.
          </li>
          <li>Площадь кабинета 32 кв. м.</li>
          <li>
            Наполняемость учебной группы соответствует количеству посадочных
            мест и не должна превышать 20 человек.
          </li>
          <li>
            Учебное оборудование, технические средства обучения,
            учебно-наглядные пособия, информационные материалы представлены в
            полном объеме в соответствии с требованиями образовательных программ
            профессиональной подготовки водителей транспортных средств категории
            «А», категории «В». (Перечень представлен в Приложениях к
            образовательным программам)
          </li>
        </ul>
      </p>
      <p>
        <ul className="list_no-style">
          <li className="important">
            Сведения о закрытой площадке или автодроме
          </li>
          <li>
            Практические занятия осуществляются на оборудованной закрытой
            площадке и на маршрутах города (маршруты утверждены ГИБДД г. Перми).
          </li>
          <li>
            Закрытая площадка автодром для первоначального обучения вождению
            расположена по адресу: г. Пермь, ул. Соликамская, 286.
          </li>
          <li>
            Используется образовательной организацией на условии субаренды от
            01.01.2019 года, бессрочно.
          </li>
          <li>Площадь площадки автодрома 8,01 га.</li>
        </ul>
      </p>
      <p>
        <span className="important">
          Сведения о наличии в учебном заведении учебных автомобилей
        </span>
        <ul className="list_no-style">
          <li className="important">
            Список учебных транспортных средств образовательной организации:
          </li>
          <li>Легковой автомобиль Лада Гранта</li>
          <li>Легковой автомобиль Лада Веста</li>
          <li>Легковой автомобиль Renault Sandero</li>
          <li>Мотоцикл Lifan LF 200 GY-3B</li>
          <li>Мотоцикл BAJAJ BOXER BM 150X</li>
        </ul>
      </p>
      <p>
        Подробные сведения о транспортных средствах представлены в следующем
        документе:
        {generateLinks([
          "Сведения о наличии в собственности или на ином законном основании оборудованных учебных транспортных средств.pdf"
        ])}
      </p>

      <h4>Библиотека. Информационно-образовательные ресурсы.</h4>
      <h5>
        Сведения о наличии печатных и электронных образовательных и
        информационных ресурсов.
      </h5>
      <h5>
        Раздел 1. Обеспечение образовательной деятельности печатными изданиями и
        электронными учебно-методическими материалами
      </h5>
      <p>
        Наименование образовательной программы, предметов, курсов, дисциплин
        (модулей) в соответствии с учебным планом по каждой заявленной
        образовательной программе):
        <ol className="list_ordered">
          <li>
            Образовательные программы профессиональной подготовки водителей ТС
            различных категорий
            <ul>
              <li>
                АВТОШКОЛА. Автомобиль. Образование. Безопасность – ежемесячный
                журнал, Москва: компания «Автополис».
              </li>
              <li>
                Вестник автошкол. Автопросвещение. – Всероссийское периодическое
                издание. Москва: МААШ
              </li>
            </ul>
          </li>
          <li>
            Психофизиологоческие основы деятельности водителя. Основы
            психологии.
            <ul>
              <li>
                Курс лекций по учебному предмету «Психофизиологические основы
                деятельности водителя» для преподавателей автошкол. – М.: НПО
                «Зарница», 2014.
              </li>
              <li>
                Усольцева И.В. Психологические основы безопасного управления
                транспортным средством. – М.: Автополис-плюс, 2009
              </li>
              <li>
                Шувалова С.А. Психологическая подготовка водителя. –
                Ростов-на-Дону: Феникс, СПб, 2007.
              </li>
              <li>
                Денисова Ю.В. Психологические основы безопасного управления
                транспортными средствами. – Автошкола МААШ, 2012.
              </li>
            </ul>
          </li>
          <li>
            Основы законодательства в сфере дорожного движения.
            <ul>
              <li>
                Правила дорожного движения Российской Федерации (утверждены
                Постановлением Совмина-Правительства РФ от 23.10.1993 г. №1090)
                с последними изменениями
              </li>
              <li>
                Жульнев Н.Я.: Учебник водителя. Правила дорожного движения. –
                М.ООО «Книжное издательство «За рулем» 2008
              </li>
              <li>
                Жульнев Н.Я. Правила дорожного движения для начинающих 2014. –
                Москва: Эксмо, 2014.
              </li>
              <li>
                Зеленин С.Ф.: Правила дорожного движения с комментариями для
                всех понятным языком. – М.ООО «Мир Автокниг» 2008.
              </li>
              <li>
                Тематические задачи для подготовки к экзаменам в ГИБДД водителей
                ТС категорий «А» и «В» с комментариями под ред. С.Ф.Зеленина: –
                М.ООО «Мир Автокниг» 2012.
              </li>
              <li>
                Громоковский Г., Бачманов С., Репин: Экзаменационные задачи
                тематические с комментариями «А», «В» - М: ИД «Третий Рим» 2014.
              </li>
            </ul>
          </li>
          <li>
            Основы управления транспортными средствами различных категорий.
            <ul>
              <li>
                Шухман Ю.И. Основы управления автомобилем и безопасность
                движения. – ООО «КИ «За рулем», 2008.
              </li>
              <li>
                Зеленин С.Ф. Безопасность дорожного движения в экзаменационных
                билетах и в жизни. – М.: ООО «Мир Автокниг». 2008
              </li>
              <li>
                Копусов-Долинин А.И. Автошкола 2014. Системная методика
                подготовки надежного водителя. – М: Эксмо, 2014.
              </li>
              <li>
                Ксенофонтов И.В. Основы управления мотоциклом и безопасность
                движения. Учебник водителя. – М.: ИЦ Академия, 2013
              </li>
            </ul>
          </li>
          <li>
            Устройство и техническое обслуживание транспортных средств как
            объектов управления. Конструкция, устройство и эксплуатация
            транспортных средств.
            <ul>
              <li>
                Родичев В.А., Кива А.А. Устройство и техническое обслуживание
                легковых автомобилей. Учебник водителя. – М. ИЦ «Академия»,
                2008.
              </li>
              <li>
                Яковлев В.Ф. Учебник по устройству легкового автомобиля. – М.:
                ООО «Третий Рим», 2014.
              </li>
              <li>
                Ксенофонтов И.В. Устройство и техническое обслуживание
                мотоциклов. Учебник водителя. – М.: ИЦ Академия, 2010
              </li>
              <li>
                Афонин С.В. Электрооборудование мотоциклов отечественного и
                иностранного производства. Практическое руководство. – М.:
                Третий Рим, 2003
              </li>
            </ul>
          </li>
          <li>
            Организация и выполнение грузовых перевозок автомобильным
            транспортом. Организация и выполнение пассажирских перевозок
            автомобильным транспортом. Законодательные и нормативные акты,
            регламентирующие подготовку водителей транспортных средств.
            <ul>
              <li>
                Смагин А.В: Правовые основы деятельности водителя. 6-е изд. –
                М.: ИЦ «Академия» 2008.
              </li>
              <li>
                Федеральный закон «О безопасности дорожного движения» от 10
                декабря 1995 г. № 196-ФЗ с изменениями от 2014 г.
              </li>
              <li>
                Правила дорожного движения, Утверждены Постановлением Совета
                Министров – Правительства Российской Федерации от 23 октября
                1993 г. № 1090.
              </li>
              <li>
                Основные положения по допуску транспортных средств к
                эксплуатации и обязанности должностных лиц по обеспечению
                безопасности дорожного движения, Утверждены Постановлением
                Совета Министров – Правительства Российской Федерации от 23
                октября 1993 г. № 1090.
              </li>
              <li>
                Федеральный закон РФ от 08.11.2007 № 259-ФЗ «Устав
                автомобильного транспорта и городского наземного электрического
                транспорта» (с изменениями от.03.02.2014).
              </li>
              <li>
                Федеральный закон от 10 декабря 1995 г. № 196-ФЗ «О безопасности
                дорожного движения»
              </li>
              <li>
                Федеральный закон от 29 декабря 2012 г. № 273-ФЗ «Об образовании
                в Российской Федерации»
              </li>
              <li>
                Спирин И. Организация и управление пассажирскими автомобильными
                перевозками – М.: Академия, 2005.
              </li>
            </ul>
          </li>
          <li>
            Первая помощь при дорожно-транспортных происшествиях.
            <ul>
              <li>
                Николенко В.Н и др. Первая доврачебная медицинская помощь.
                Учебник водителя. 6-е изд. – М.: ИЦ «Академия», 2008.
              </li>
              <li>
                Сидорович И.А. Оказание первой медицинской помощи пострадавшим
                при ДТП. Учебное пособие – М. Эксмо, 2008.
              </li>
              <li>
                Захарова А.Е. Экстренная помощь при ДТП. М.:ООО «Мир автокниг»,
                2010.
              </li>
              <li>
                Дежурный Л.И., Неудахин Г.В. и др. Обучение первой помощи в
                автошколе. Пособие для преподавателей и инструкторов. – 2014.
              </li>
              <li>
                Корпусов-Долинин А.И. Автошкола 2014. Системная методика
                подготовки надежного водителя. – М: Эксмо, 2014.
              </li>
              <li>
                Н.М. Федоровский. Сердечно-легочная реанимация. Клинические
                рекомендации – М. МИА, 2013 г.
              </li>
              <li>
                Азбука первой помощи пострадавшим в ДТП,- М, ТД МААШ, 2010
              </li>
            </ul>
          </li>
          <li>
            Вождение транспортного средства.
            <ul>
              <li>
                Яковлев В.Ф. Учебник по вождению легкового автомобиля. – М.: ООО
                «Третий Рим», 2014.
              </li>
              <li>
                Копусов-Долинин А.И. Автошкола 2014. Системная методика
                подготовки надежного водителя. – М: Эксмо, 2014.
              </li>
              <li>
                Шухман Ю.И. Основы управления автомобилем и безопасность
                движения. – ООО «КИ «За рулем», 2008.
              </li>
              <li>
                Шельман Е. Курс вождения автомобиля. Обновленное издание (с
                анимационной тренинг системой по ПДД) – Спб.: Питер, 2014.
              </li>
              <li>
                Зеленин С.Ф. Учебник по вождению автомобиля. – М.: ООО «Мир
                автокниг», 2009
              </li>
              <li>
                Сорокин Н. Спецкурс по вождению и ПДД. Только самое важное и
                необходимое.
              </li>
              <li>
                Савченко С.В. Вождение автомобиля. Самоучитель. 3-е изд. – М.:
                «Налоговый вестник», 2007
              </li>
              <li>
                Николаев А.Н. Подготовка по вождению кандидатов в водители.
                Учебное пособие для мастеров ПО. – Москва-Владивосток ООО УКЦ
                МААШ, 2008
              </li>
            </ul>
          </li>
        </ol>
      </p>
      <h5>
        Раздел 2. Обеспечение образовательной деятельности электронными
        информационными ресурсами
      </h5>
      <p>
        Наличие технических средств обеспечения доступа к электронным
        информационным образовательным ресурсам:
        <br />
        Компьютер в сборе, мультимедийный проектор, экран (доска) для
        отображения информации. Наличие доступа в сеть Интернет.
      </p>
      <p>
        Наличие специализированного программного обеспечения для проверки знаний
        по теоретическим дисциплинам.
        <ul>
          Наименование и краткая характеристика электронных образовательных и
          информационных ресурсов (информационные и образовательные сайты,
          порталы):
          <li>Автотрибуна. Портал для автошкол. www.autotribuna.ru</li>
          <li>Межрегиональная ассоциация автошкол. www.maash.ru</li>
          <li>ПДД-мастер www.pddmaster.ru</li>
          <li>Гильдия автошкол. www.autogild.ru</li>
          <li>Госавтоинспекция РФ www.gibdd.ru</li>
          <li>Автобегиннер www.avtobeginner.ru</li>
          <li>За рулем РФ www.zr.ru</li>
          <li>АвтоГАИ www.avtogai.ru</li>
          <li>Автополис www.autopolis.ru</li>
        </ul>
      </p>
      <p>
        Данные сайты являются информационными и образовательными с точки зрения
        содержащейся в них информации о нововведениях в сфере подготовки
        водителей транспортных средств, а так же изменениях в законодательстве.
        На них содержится различная обучающая информация, происходит обмен
        опытом между руководителями и педагогами автошкол, рекомендации по
        организации образовательного процесса, обсуждение ключевых задач и
        проблем подготовки водителей. Рекомендуются к использованию для
        курсантов автошколы.
      </p>
      {generateLinks([
        "Материально техническое обеспечение образовательного процесса.pdf",
        "Положение о порядке пользования учебниками, учебными пособиями и другой методической литературой обучающимися.pdf"
      ])}
    </article>
  );
}

function Support() {
  return (
    <article>
      <p>
        <ul className="list_no-style">
          <li>
            Обучение является платным, не подлежит бюджетному финансированию.
          </li>
          <li>
            Стипендии и иные виды материальной поддержки в образовательной
            организации не предусмотрены.
          </li>
          <li>
            Общежитие или интернат для местных или иногородних обучающихся не
            предоставляется.
          </li>
          <li>Содействие в трудоустройстве выпускников не предусмотрено.</li>
        </ul>
      </p>
      <p>
        <h5>Реализуемые меры поддержки:</h5>
        <ul className="list_no-style">
          <li>
            Для учащихся предусмотрена рассрочка платежа за курс обучения по
            образовательным программам. В отдельных случаях предлагаются скидки
            на оплату стоимости обучения.
          </li>
          <li>
            Кроме того проводятся различные акции, направленные на повышение
            привлекательности процесса подготовки водителей, в рамках которых
            предлагаются различные скидки по оплате стоимости обучения.
          </li>
          <li>
            Автошкола предоставляет полный пакет документов, позволяющий в
            соответствии с положениями 219 статьи Налогового кодекса РФ получить
            социальный налоговый вычет на обучение в размере 13% стоимости.
          </li>
        </ul>
      </p>
    </article>
  );
}

function Paid() {
  return (
    <article>
      <p>
        Обучение является платным, не подлежит бюджетному финансированию.
        Бюджетные места не предусмотрены.
      </p>
      <p>
        Платные образовательные услуги предоставляются в соответствии с
        Постановлением Правительства РФ от 15.08.2013 №706 о Правилах
        предоставления этих услуг.
      </p>
      <p>
        Порядок оказания платных образовательных услуг предусмотрен локальными
        нормативными актами:
        {generateLinks([
          "Положение об оказании платных образовательных услуг Дизель.pdf",
          "Приказ о стоимости обучения по программе подготовки категории А.pdf",
          "Приказ о стоимости обучения по программе подготовки категории В.pdf"
        ])}
      </p>
      <p>
        Пример договора на оказание платных услуг:
        {generateLinks([
          "Образец договора об оказании платных образовательных услуг.pdf"
        ])}
      </p>
    </article>
  );
}

function Finance() {
  return (
    <article>
      <p>
        {" "}
        ЧУ ДПО "Дизель" не имеет бюджетного финансирования, предоставляет
        обучающимся платные образовательные услуги по подготовке водителей
        транспортных средств различных категорий на основании договоров об
        оказании платных образовательных услуг.
      </p>
      <p>
        Объем образовательной деятельности, финансовое обеспечение которой
        осуществляется:
        <ul>
          <li>за счет бюджетных ассигнований федерального бюджета – нет;</li>
          <li>бюджетов субъектов Российской Федерации – нет;</li>
          <li>местных бюджетов – нет;</li>
          <li>
            по договорам об образовании за счет средств физических и (или)
            юридических лиц – ежегодный прием рассчитан на 152 человека.
          </li>
        </ul>
      </p>
      <p>
        ЧУ ДПО "Дизель" является негосударственной образовательной организацией,
        в связи с чем не имеет бюджетного финансирования и вся его финансовая
        деятельность основывается на доходах, получаемых за образовательные
        услуги от обучающихся.
      </p>
      <p>
        Все средства, полученные автошколой, расходуются на обеспечение и
        развитие образовательного процесса. В связи с внедрением новых
        образовательных программ в 2014 году значительная доля финансовых
        средств была направлена на модернизацию материально-технической базы с
        целью приведения ее в соответствие требованиям программ профессиональной
        подготовки водителей. Ежегодно основные затраты идут на содержание
        автошколы, оплату услуг ЖКХ, стоимости ГСМ, заработную плату, развитие
        учебно-материальной базы (оснащение учебных кабинетов современными
        информационными ресурсами и оборудованием), выполнение технического
        обслуживания и страхование транспортных средств, арендную плату за
        предоставленные в пользование автодром, помещения, автомобили и т.п.
      </p>
      <p>
        Большое внимание уделяется вопросам перспективы развития автошколы,
        осваиваются новые инновационные технологии обучения, осуществляется
        разработка и внедрение современной дидактики с использованием
        информационно-коммуникационных технологий. Автошкола перечисляет налоги
        и выполняет свои обязательства по договорам аренды и оплаты услуг ЖХ.
      </p>
      <p>
        В 2019 финансовом году планируется израсходовать средства на дальнейшее
        развитие учебно-материальной базы: совершенствование дидактики,
        приобретение мультимедийных учебных пособий и др.
      </p>
      {generateLinks([
        "План финансово-хозяйственной деятельности на 2022-2023 гг.pdf",
        "Программа развития до 10 января 2021 года.pdf"
      ])}
    </article>
  );
}

function Spaces() {
  return (
    <article>
      <p>
        Бюджетные места не предусмотрены. Обучение является платным, не подлежит
        бюджетному финансированию за счет бюджетных ассигнований федерального
        бюджета, бюджетов субъектов Российской Федерации, местных бюджетов.
      </p>
      <p>
        Обучение осуществляется на платной основе за счет средств физических или
        юридических лиц.
      </p>
      <p>
        Вакантных мест для приема на обучение по программам профессионального
        обучения водителей транспортных средств категории А и категории В на
        договорной основе за счет средств физических и (или) юридических лиц
        согласно Акта обследования учебно-материальной базы УГИБДД ГУ МВД России
        по Пермскому краю – 152.
      </p>
      <p>
        Перевод из других образовательных учреждений возможен на договорной
        основе за счет средств физических и (или) юридических лиц.
      </p>
      <p>
        Результаты приема:
        <br />
        Все кандидаты, подавшие заявление на обучение, не имеющие медицинских
        противопоказаний и ограничений по возрасту, могут быть приняты на
        обучение в автошколу.
      </p>
      <p>
        Условия приема на обучение:
        <ul>
          <li>подача заявления слушателем;</li>
          <li>заключение договора на оказание платных образовательных услуг</li>
          <li>
            предоставление медицинской справки об отсутствии противопоказаний;
          </li>
          <li>
            достижение возраста 17 лет – для ТС категории В, 18 лет - для ТС
            категории А.
          </li>
        </ul>
      </p>
      <p>
        Обучение по программе подготовки ТС категории А производится в период с
        апреля по октябрь; на ТС категории В – круглогодично.
      </p>
      <p>Вступительных испытаний – нет.</p>
      <p>
        Отчисление учащихся осуществляется согласно условиям договора об
        оказании образовательных услуг.
      </p>
      {generateLinks([
        "Аккредитация (Заключение УГИБДД).pdf",
        "Акт обследования учебно-материальной базы УГИБДД ГУ МВД России по Пермскому краю.pdf"
      ])}
    </article>
  );
}

export default [
  { name: "Основные сведения", component: <Main /> },
  {
    name: "Структура и органы управления образовательной организацией",
    component: <Structure />
  },
  { name: "Документы", component: <Documents /> },
  { name: "Образование", component: <Education /> },
  { name: "Образовательные стандарты", component: <EducationStandart /> },
  { name: "Руководство. Педагогический состав", component: <Manager /> },
  {
    name:
      "Материально-техническое обеспечение и оснащенность образовательного процесса",
    component: <Staff />
  },
  {
    name: "Стипендии и иные виды материальной поддержки",
    component: <Support />
  },
  { name: "Платные образовательные услуги", component: <Paid /> },
  { name: "Финансово-хозяйственная деятельность", component: <Finance /> },
  { name: "Вакантные места для приема (перевода)", component: <Spaces /> }
];



// WEBPACK FOOTER //
// ./src/components/Information/Articles.jsx